import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedHelpMainHeader = () => {
  return {
    title: "",
    logoUrl: "",
    active: true,
    middleHeaders: [],
    ungroupedSubHeaders: [],
    subHeaders: [],
  };
};

export default {
  state: () => ({
    selectedHelpMainHeader: getDefaultSelectedHelpMainHeader(),
    helpMainHeaders: [],
  }),

  mutations: {
    setSelectedHelpMainHeader(state, helpMainHeader) {
      Vue.set(state, "selectedHelpMainHeader", helpMainHeader);
    },
    setHelpMainHeaders(state, helpMainHeaders) {
      Vue.set(state, "helpMainHeaders", helpMainHeaders);
    },
    setDefaultSelectedHelpMainHeader(state) {
      Vue.set(state, "selectedHelpMainHeader", getDefaultSelectedHelpMainHeader());
    },
    setDefaultHelpModule(state) {
      Vue.set(state, "selectedHelpMainHeader", getDefaultSelectedHelpMainHeader());
      Vue.set(state, "helpMainHeaders", []);
    },
  },

  actions: {
    createHelpMainHeader: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/help-main-headers/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    uploadHelpImage: (context, request, config = { headers: { "Content-Type": "multipart/form-data" } }) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/storage/upload/help?environment=" + context.getters.getEnvironment, request, config)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadHelpMainHeaders: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/entity").then((response) => {
        context.commit("setHelpMainHeaders", response.data);
        return response.data;
      });
    },

    loadHelpMainHeader: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/entity/" + request.id).then((response) => {
        context.commit("setSelectedHelpMainHeader", response.data);
        return response;
      });
    },

    loadSelectedHelpMainHeaderHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteHelpMainHeader: (context, helpMainHeader) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/help-main-headers/entity/" + helpMainHeader.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          helpMainHeader.intents = intents;
          helpMainHeader.intentId = response.data.id;
          return helpMainHeader;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    deleteDraftHelpMainHeader: (context, helpMainHeader) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/help-main-headers/draft/" + helpMainHeader.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishHelpMainHeader: (context, helpMainHeader) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/publish/" + helpMainHeader.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectHelpMainHeader: (context, helpMainHeader) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/reject/" + helpMainHeader.intentId).then((response) => {
        if (helpMainHeader.intents[0].type === "DELETE_HELP") {
          helpMainHeader.intents = null;
          helpMainHeader.intentId = 0;
        } else if (helpMainHeader.intents[0].type === "CREATE_HELP") {
          helpMainHeader.intents[0].status = "DRAFT";
        } else if (helpMainHeader.intents[0].type === "UPDATE_HELP") {
          helpMainHeader.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalHelpMainHeader: (context, helpMainHeader) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/sendToApproval/" + helpMainHeader.intentId).then((response) => {
        if (helpMainHeader.intents[0].type === "CREATE_HELP") {
          helpMainHeader.intents[0].status = "WAITING_APPROVAL";
        } else if (helpMainHeader.intents[0].type === "UPDATE_HELP") {
          helpMainHeader.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallHelpMainHeader: (context, helpMainHeader) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/recall/" + helpMainHeader.intentId).then((response) => {
        helper.recallOrRejectEntity(helpMainHeader, "help");
        return response.data;
      });
    },

    cancelHelpMainHeader: (context, helpMainHeader) => {
      return axios.get(context.getters.getMcServiceUrl + "/help-main-headers/cancel/" + helpMainHeader.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedHelpMainHeader: (state) => {
      return state.selectedHelpMainHeader;
    },
    getHelpMainHeaders: (state) => {
      return state.helpMainHeaders;
    },
  },
};
